import { Dispatch } from 'redux';
import { api } from '../../service/api';

import showNotificationMessage, {
  notificationTypes,
} from './notificationHelper';

export const JOBS_ACTIONS = {
  JOBS_LOADING: 'JOBS_LOADING',
  LOGS_LOADING: 'LOGS_LOADING',
  SET_JOBS: 'SET_JOBS',
  SET_LOGS: 'SET_LOGS',
};
export const getJobs = () => (dispatch: Dispatch) => {
  dispatch({
    type: JOBS_ACTIONS.JOBS_LOADING,
    payload: 'loading',
  });
  api
    .getScheduledJobs()
    .then((res) => {
      dispatch({
        type: JOBS_ACTIONS.SET_JOBS,
        payload: res.data,
      });
      dispatch({
        type: JOBS_ACTIONS.JOBS_LOADING,
        payload: 'loaded',
      });
    })
    .catch((err) => {
      console.log(err);
      showNotificationMessage(
        notificationTypes.error,
        `Failed to get Jobs`,
        dispatch
      );
      dispatch({
        type: JOBS_ACTIONS.JOBS_LOADING,
        payload: 'failed',
      });
    });
};

export const getJobExecutionLogs =
  (clientId: string | number, date: string) => (dispatch: Dispatch) => {
    dispatch({
      type: JOBS_ACTIONS.LOGS_LOADING,
      payload: 'loading',
    });
    api
      .getJobExecutionLogs(clientId, date)
      .then((res) => {
        dispatch({
          type: JOBS_ACTIONS.SET_LOGS,
          payload: { clientId, date, data: res.data },
        });
        dispatch({
          type: JOBS_ACTIONS.LOGS_LOADING,
          payload: 'loaded',
        });
      })
      .catch((err) => {
        console.log(err);
        showNotificationMessage(
          notificationTypes.error,
          `Failed to get Job logs`,
          dispatch
        );
        dispatch({
          type: JOBS_ACTIONS.LOGS_LOADING,
          payload: 'failed',
        });
      });
  };
